import React from "react"
import { ReactFC } from "types"
import { Post } from "posts/posts.types"
import { EventData } from "posts/EventData"
import { TimeLine } from "./EventTime"
import styled from "styled-components"
import { FormattedDate, FormattedMessage } from "react-intl"
import { eventMargin } from "./styles"
import styles from './EventDate.css'


const DateWrapper = styled.h3`
`
const TimeWrapper = styled.div`
`

export const Container = styled.div`
`

const OneLineDate = styled(DateWrapper)`
`

const DiscussionDate: ReactFC<{ post: Post }> = ({ post }) => {

  const event = new EventData(post)

  return (
    <Container className={styles.event_date}>
      <OneLineDate>
        <span><FormattedMessage id="event.startsPrefix" />&nbsp;</span>
        <FormattedDate
          value={event.localStartTime}
          year="numeric"
          month="short"
          day="2-digit"
          hour="numeric"
          minute="numeric"
        />
      </OneLineDate>
      <OneLineDate>
        <span><FormattedMessage id="event.endsPrefix" />&nbsp;</span>
        <FormattedDate
          value={event.localEndTime}
          year="numeric"
          month="short"
          day="2-digit"
          hour="numeric"
          minute="numeric"
        />
      </OneLineDate>
    </Container>
  )
}

export const EventDate: ReactFC<{ post: Post }> = ({ post }) => {

  if (!post?.event) {
    return null
  }

  if (post.type === "discussion") {
    return <DiscussionDate post={post} />
  }

  const event = new EventData(post)

  return (
    <Container className={styles.event_date}>
      <DateWrapper>
        <FormattedDate
          value={event.localStartTime}
          year="numeric"
          month="long"
          day="2-digit"
        />
      </DateWrapper>
      <TimeWrapper>
        <TimeLine prefix={<FormattedMessage id="event.startsPrefix" />} time={event.localStartTime} />
        <TimeLine prefix={<FormattedMessage id="event.endsPrefix" />} time={event.localEndTime} />
      </TimeWrapper>
    </Container>
  )
}

export default EventDate
